import React from 'react';

const BackIcon = () => (
  <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M24.3562 11H9.49882L16.3186 5.4L14.6137 4L4.87109 12L14.6137 20L16.3186 18.6L9.49882 13H24.3562V11Z" fill="#231F20" />
  </svg>
);

export default BackIcon;
